import React from "react";
import { Onboarding } from "../../../../components";

const OnboardingList = () => {
  return (
    <div className="flex flex-1">
      <Onboarding />
    </div>
  );
};

export default OnboardingList;
